/**
 * Drag-and-drop layout item ids for dynamic tabs and custom tabs.
 * Same pattern as CommunityTransfer.js / Admission.js (generateDefaultLayout + cardData).
 */

export function getDynamicCardLayoutId(accessor) {
	return `dynamic_${accessor}`;
}

export function getCustomTabCardLayoutId(accessor) {
	return `custom_${accessor}`;
}

/**
 * Maps a Redux "selected cards" key (accessor) to the grid layout id.
 * Built-in hospital/community cards keep their key as the layout id.
 */
export function resolveLayoutCardIdForSelectedCard(cardSelectionKey, dynamicCards, customTabs) {
	if (dynamicCards?.some((d) => d?.accessor === cardSelectionKey && !d?.isDefaultCard)) {
		return getDynamicCardLayoutId(cardSelectionKey);
	}
	if (customTabs?.some((t) => t?.accessor === cardSelectionKey && !t?.isDefaultCard)) {
		return getCustomTabCardLayoutId(cardSelectionKey);
	}
	return cardSelectionKey;
}
